/**
 * @brief 新建编辑页面关联对象表格数据存储store
 * @date 2025年12月05日16:02:12
 * @author zl
 */
import { defineStore } from 'pinia';

export const useFormTableStore = defineStore('formTable', {
  state: () => ({
    tableData: {}, //表格数据
    tableAssociateIdData: {}, //表格批量新建绑定查找关联字段id数据
    tableRequiredErrorData: [] //必填字段未填写集合
  }),
  actions: {
    /**
     * @brief 设置表格数据
     * @param id 对应表格在表单设计中的id
     * @param _tableData 表格数据
     */
    setTableData(id, _tableData) {
      this.tableData = {
        ...this.tableData,
        [id]: _tableData
      };
    },
    //设置关联字段id集合 目前触发场景为：1. 批量新建 2. 编辑修改查找关联值 3. 快捷编辑 4. 新增数据 5. 删除数据
    setTableAssociateIdData(id, _tableAssociateIdData) {
      this.tableAssociateIdData = {
        ...this.tableAssociateIdData,
        [id]: _tableAssociateIdData
      };
    },
    //设置必填字段未填写错误提示数据
    setTableRequiredErrorData(_tableRequiredErrorData) {
      this.tableRequiredErrorData = _tableRequiredErrorData;
    }
  }
});
export default useFormTableStore;
